<template>
	<div class="public_top">
		<div class="public_top_logo">
			<img src="../assets/logo.png">
			<span>{{msg}}</span>
		</div>
		<div class="public_top_info">
			<p>欢迎使用雷达创建任务任务名称任务类型等信息XXX平台！</p>
			<span>2021/12/23  星期四</span>
			<time>12:07:23</time>
		</div>
	</div>
</template>

<script>
	export default {
	  props: {
	    msg: String
	  }
	}
</script>

<style>
	.public_top{
		height: 37px;
		border-bottom: 2px solid #00d3e7;
		border-image: -webkit-linear-gradient(to right,rgba(27, 69, 118, 0.23), rgba(34, 249, 230, 0.5),rgba(27, 69, 118, 0.54)) 20 20;
		border-image: -moz-linear-gradient(to right,rgba(27, 69, 118, 0.23), rgba(34, 249, 230, 0.5),rgba(27, 69, 118, 0.54)) 20 20;
		border-image: -o-linear-gradient(to right,rgba(27, 69, 118, 0.23), rgba(34, 249, 230, 0.5),rgba(27, 69, 118, 0.54)) 20 20;
		border-image: linear-gradient(to right,rgba(27, 69, 118, 0.23), rgba(34, 249, 230, 0.5),rgba(27, 69, 118, 0.54)) 20 20;
	}
	.public_top_logo{
		display: inline-block;
	    overflow: hidden;
		width: 20%;
		background-image: url(../assets/pucbg1.png);
		background-repeat: no-repeat;
		background-position: left top;
		background-size: 100% 100%;
	    padding: 8px 60px;
	    border-right: 1px solid #2bfee7;
	    border-bottom-right-radius: 60px;float: left;}
	.public_top_logo img{vertical-align: middle;width: 32px;}
	.public_top_logo span{font-weight: bold;
	    font-size: 17px;
	    line-height: 33px;
	    vertical-align: middle;
	    color: #ffffff;
		padding: 0 40px 0 10px;
		    width: 10em;
		    overflow: hidden;
		    display: inline-block;
		    white-space: nowrap;
		    overflow: hidden;
		    text-overflow: ellipsis;
	}
	.public_top_info{display: inline-block;vertical-align: top;width: 69%;padding-right: 1%}
	.public_top_info time,.public_top_info span{float: right;}
	.public_top_info p,.public_top_info time,.public_top_info span{display: inline-block;line-height: 36px;letter-spacing: 1px;color: #ffffff;}
	.public_top_info p{font-size: 14px;opacity: 0.6;}
	.public_top_info time{font-size: 18px;margin-right: 30px;}
	.public_top_info span{font-size: 18px;}
</style>
